<template>
    <section>
        <slot
            :showItem="showItem"
            :activeItem="activeItem"
            :windowWidth="windowWidth"
            :showContainer="showContainer"
            :setActiveItem="setActiveItem"
        />
    </section>
</template>

<script>
    export default {
        name: 'BaseHero',
        data() {
            return {
                activeItem: 0,
                showItem: true,
                windowWidth: 0,
                showContainer: false,
            };
        },
        methods: {
            setActiveItem(itemIndex) {
                this.activeItem = itemIndex;
                this.showItem = false;
            },
            getWindowWidth() {
                this.windowWidth = document.documentElement.clientWidth;
            },
        },
        mounted() {
            setTimeout(
                () => { this.showContainer = true; },
                500,
            );

            this.$nextTick(() => {
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
        },
    };
</script>



// WEBPACK FOOTER //
// BaseHero.vue?48a17d8e